import React from "react";
import { Camera } from "lucide-react";

/**
 * OPTIONAL consent checkbox — recorded on the registration and shown to admins/instructors.
 * Copy is admin-friendly and legally defensive.
 */
export default function PhotoConsentCheckbox({ checked, onChange, testId = "photo-consent" }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none border border-red-600/30 bg-red-600/5 px-3 py-3 mb-3 hover:border-red-600/60 transition-colors" data-testid={testId}>
      <input
        type="checkbox"
        required
        aria-required="true"
        checked={!!checked}
        onChange={e => onChange(e.target.checked)}
        className="mt-0.5 accent-red-600"
        data-testid={`${testId}-input`}
      />
      <span className="text-xs text-zinc-300 leading-relaxed">
        <span className="inline-flex items-center gap-1 mr-1 text-white uppercase tracking-widest text-[10px]">
          <Camera size={11}/> Photo &amp; video consent
        </span>
        (Optional) I understand that photos and videos may be taken during classes, workshops or events and
        may be used on 2RightFeet's website, social media and promotional material. If I do NOT
        consent I will let the instructor know in writing before my first class.
      </span>
    </label>
  );
}
